export const SERVICE_HISTORY_AGE_LIMIT = 5;
